/**
 * Constructs a venue URL for a given venue Id.
 * @param {number} venueId Id of the venue.
 * @returns {string} Venue URL for a given venue Id.
 */
export const getVenueUrl = (venueId: number): string => `/venues/${venueId}`;
